import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/tmp/622d26c3/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ResourceCard = makeShortcode("ResourceCard");
const MdxIcon = makeShortcode("MdxIcon");
const Caption = makeShortcode("Caption");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3 {...{
      "id": "this-is-the-roadmap-for-the-carbon-design-system-based-on-our-planned-design-and-development-path-it-is-a-list-of-our-priorities-in-various-broad-initiative-areas"
    }}>{`This is the roadmap for the Carbon Design System, based on our planned design and development path. It is a list of our priorities in various broad initiative areas.`}</h3>
    <AnchorLinks mdxType="AnchorLinks">
      <AnchorLink mdxType="AnchorLink">Icon updates</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Workshop curriculum</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Content audit and strategy</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Component specification</AnchorLink>
      <AnchorLink mdxType="AnchorLink">IDL site QA and release</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Contribution model</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Continued support</AnchorLink>
    </AnchorLinks>
    <h2 {...{
      "id": "resources"
    }}>{`Resources`}</h2>
    <Row className="tile--group" mdxType="Row">
      <Column colMd="4" colLg="4" noGutterSm mdxType="Column">
    <ResourceCard subTitle="See more on GitHub" href="https://github.com/carbon-design-system/carbon/issues/3403" mdxType="ResourceCard">
          <MdxIcon name="github" mdxType="MdxIcon" />
  </ResourceCard>
      </Column>
    </Row>
    <h2 {...{
      "id": "icon-updates"
    }}>{`Icon updates`}</h2>
    <p>{`This plan captures our work on the icons project for `}<strong parentName="p">{`August 2019`}</strong>{`. This work will result in the general availability of the IBM Design Language iconography assets in design tooling, code, and on the site. It also includes work to introduce pictograms into the system, alongside general enhancements to our icon contribution process.`}</p>
    <h4 {...{
      "id": "primary-goals"
    }}>{`Primary goals`}</h4>
    <ul>
      <li parentName="ul">{`Deliver an Elements Design Kit to replace the existing IBM Design Language Kit and update our existing Design Kits`}</li>
      <li parentName="ul">{`Deliver an improved website experience for finding icons`}</li>
      <li parentName="ul">{`Introduce a new pictogram package`}</li>
    </ul>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "115.65276828434723%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAXCAYAAAALHW+jAAAACXBIWXMAAAsSAAALEgHS3X78AAAFJklEQVQ4y3WUe2wURRzH527vtXe792jv0SvtFbn2unu31we3d7v36uO6ey0FkailSBUJFINCgoKBiIRHW0tpSowh0UQEYoOIFjTUKpECNiYCYgwtBogJRDEKhRZMBGP86/zt3LWIlkl+mdnZ3c98vzO/3yCUaxkug9DTaMa2nx+iOaGJKhcbjKwgU6woU4woKXOE8t4nppBfSGc/PhUayw6iBbirE9o0m8JvEsf4MxokI/Ql/731CD/iLxDDjkqhmawWFqhmiwnUJKx4aFGPGEclELh9wZ/H/bnQVXJJZL11fbiXOhr5hkIxG/k+f7wQ4MVWMWgGRVZQRwaFeWq3GCH2hD8iBvkzao8YU02TT4LC06GLeDzMX6AzTEb1X8sf8CdIsOQCm26wbKkApRYxaDrAD5kH+BE3WHYzgkRmLfOjWTA/SoB9agpSve0CycrLrBxfbymKJWkm1qSbaX/38YMqRTEAVTnQWG4vRzXD/ANgoOuH2Wz6+WI2lHT75ybdTChpYsQ0yQoNavSIVirWPQAOh8eIE/worYz5vlv6wM4r5WUIqdmaRRqu50cjO6/dwfA1djbaCGDJqATYxzZhjEBhlno6lLU8Uj2q+zx2CX9QsemUFSCsDyEtm1pi4t6+b2EXrHExoYQChLSRzACgISyMIOPUgR6xCvT6wAT2fkEYox7f/JPZk26hAi/1F3K917zKvL/tDYLr+5lipbaCnEJQJuWgMt5XFiuUH/bfmfc1NX/D5TxlXHkgow10Xy4pd+r0/pYtRm73LxZ2/morE0nlQdpYGVG2gE0tBAEq1WwOhhVmMhkSgh7Ze9cjb79sUl5UdY4Rge5LLjbVSjIepyGwbsAc2DziZCL1xUws7QKADaBmAFoBaFaAyj5i8L37f/ZNTt69MXHn91MA1k4p5rqu0Gxju5WpqCaDH2fUge6LBq5kLsnNqtAziSYdqNEzOGT91D8KFI3fnnSN37hZev7boaqWY3tNUy+LDx4ifAtbTWwoRTIhUR8gSa3z7KCx+K0es59LQF6moZ5lGkI5daW2iYf2sP9JZJT6u21Tz4VH3qPLFrcZ2KpaPVjRsbFmvaenI3/OmrVONlRfACAHhB2UGgCmmk6bibGTKthI9NcuiVr4YY8t/5l2k/eVly3uoYOWfy9YcPyQ3bvyhbygM2CGRWgm2aTA7ADVQ6gBmk34OzsE3N/bGtJc76mjENeiqVrapnN/coD2NT9F+RnR5F2xylx4dH9R6bPLdSxfrys8/K7Du3yly1+RzGeiaRs+HFHSYNCNzhjuf+1KELd3iNOlN5xwIt+iVqI8lCKSQlJtOzGg9bY+Z/QtXGxyf9bvBaDDH0zaAAiplIWx+FA6oxgw3hHV3OyMYeCeVxfMWKurIxW4d50dJLzL2y2gkAIgDSDt/4C3OqOqmx2xaYVfbUiQ4YRkQr5G4/F1CevVbfHHygQ571EXA65nMVctv3VkbU90ReneZbX6sxvjxmtbY1Y0a57Gw8va7Utr9Z+uTdoCUYmOJVJqyFeE/picmQxW0ehr2as7s1vUgCrjuY3xooub48XOqrSdi0qOOWHZQQbS5mBUMiDzfJxv8doGdVkETleQ1WAV34esonA8dyiZPnF6kcx3lSoAWlBpo7Y6LukAqq+ta9CivGb137ui5Dsra+wlvOz2i1IBwFwAg7yUipQEx4BLr08rRO1P1OPx4ReT2khSMoIKA/xEAtSQX5kmr2yJ0ftW1dhBdRHMF0LMwkBByleq5R8qeHtSXeve4AAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Icon project workflow",
            "title": "Icon project workflow",
            "src": "/static/fff4ad9e0a9683551a99ea8c1439947b/fb070/icon-proj.png",
            "srcSet": ["/static/fff4ad9e0a9683551a99ea8c1439947b/d6747/icon-proj.png 288w", "/static/fff4ad9e0a9683551a99ea8c1439947b/09548/icon-proj.png 576w", "/static/fff4ad9e0a9683551a99ea8c1439947b/fb070/icon-proj.png 1152w", "/static/fff4ad9e0a9683551a99ea8c1439947b/fb104/icon-proj.png 1728w", "/static/fff4ad9e0a9683551a99ea8c1439947b/902fb/icon-proj.png 2304w", "/static/fff4ad9e0a9683551a99ea8c1439947b/0421e/icon-proj.png 2926w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Icon project workflow</Caption>
      </Column>
    </Row>
    <h2 {...{
      "id": "workshop-curriculum"
    }}>{`Workshop curriculum`}</h2>
    <h4 {...{
      "id": "primary-goals-1"
    }}>{`Primary goals`}</h4>
    <p>{`Create interactive materials for part 2 of Carbon workshop for ECPs and interns`}</p>
    <h4 {...{
      "id": "schedule"
    }}>{`Schedule`}</h4>
    <ul>
      <li parentName="ul">{`Introductions`}</li>
      <li parentName="ul">{`Design Language/Design Systems refresh`}</li>
      <li parentName="ul">{`Carbon Intro (discuss atomic model, open source)`}</li>
      <li parentName="ul">{`Getting set up (design environment)`}</li>
      <li parentName="ul">{`Exercise 1: Instructor Led Sketch Artifact creation`}{`*`}</li>
      <li parentName="ul">{`(Review and Questions)`}</li>
      <li parentName="ul">{`Exercise 2: Class participants use our Sketch Libraries to interpret AirBnB as IDL`}</li>
      <li parentName="ul">{`(Review and Questions)`}</li>
    </ul>
    <h2 {...{
      "id": "content-audit-and-strategy"
    }}>{`Content audit and strategy`}</h2>
    <h4 {...{
      "id": "primary-goals-2"
    }}>{`Primary goals`}</h4>
    <p>{`Our primary goal is to conduct quantitative audits and to begin qualitative audits of the Carbon Design System, to understand where Carbon stands alongside other design systems. This includes the following work:`}</p>
    <ul>
      <li parentName="ul">{`Conduct a quantitative audit to determine current breadth of components and patterns in other design systems and internal pattern libraries.`}</li>
      <li parentName="ul">{`Conduct a full audit of the Carbon site.`}</li>
      <li parentName="ul">{`Comparative analysis of other design systems and internal sites. Outcome is a list of best practices as well as things to avoid.`}</li>
    </ul>
    <h4 {...{
      "id": "stretch-goals"
    }}>{`Stretch goals`}</h4>
    <ul>
      <li parentName="ul">{`Create standardized content templates of content needed (topics, images) for components and patterns.`}</li>
      <li parentName="ul">{`Strawman IA for technical discussions`}</li>
      <li parentName="ul">{`Lo-fi prototype to support technical discussions and UX explorations`}</li>
    </ul>
    <h4 {...{
      "id": "deferred-items"
    }}>{`Deferred items`}</h4>
    <ul>
      <li parentName="ul">{`Qualitative strategic assessment of target audiences, branding/messaging, channels, workflows, competitors, and influencers.`}</li>
    </ul>
    <h2 {...{
      "id": "component-specification"
    }}>{`Component specification`}</h2>
    <h4 {...{
      "id": "members"
    }}>{`Members`}</h4>
    <p>{`The primary goal is to define the structure for a a written document that formalizes the specification for components in the Carbon Design System, alongside a structure and runner for rules to verify that specification.`}</p>
    <h4 {...{
      "id": "this-work-will-include-the-following"
    }}>{`This work will include the following`}</h4>
    <ul>
      <li parentName="ul">{`Define the minimum required sections for a component specification`}</li>
      <li parentName="ul">{`Write initial specification for the following components: Accordion, Button, and Tabs`}</li>
      <li parentName="ul">{`Implement initial rules for these components`}</li>
      <li parentName="ul">{`Run rulesets against our current implementations in core`}</li>
      <li parentName="ul">{`Reporting`}</li>
    </ul>
    <h4 {...{
      "id": "deferred-items-1"
    }}>{`Deferred items`}</h4>
    <ul>
      <li parentName="ul">{`Define the initial visual style for the specification document (more important to focus on content this project cycle)`}</li>
    </ul>
    <h2 {...{
      "id": "contribution-model"
    }}>{`Contribution model`}</h2>
    <h4 {...{
      "id": "primary-goals-3"
    }}>{`Primary goals`}</h4>
    <ul>
      <li parentName="ul">{`Define scope for contribution model workshop`}</li>
      <li parentName="ul">{`Host contribution model workshop to iterate through community model protocols/expectations`}</li>
      <li parentName="ul">{`Define a clear protocol for contributors and add-ons`}</li>
      <li parentName="ul">{`Define a clear distinction between Carbon and Community`}</li>
    </ul>
    <h4 {...{
      "id": "stretch-goals-1"
    }}>{`Stretch goals`}</h4>
    <ul>
      <li parentName="ul">{`Document workshop outcomes and protocols`}</li>
    </ul>
    <h2 {...{
      "id": "idl-site-qa-and-release"
    }}>{`IDL site QA and release`}</h2>
    <h4 {...{
      "id": "overview"
    }}>{`Overview`}</h4>
    <p>{`We plan to launch the updated IBM Design Language website using the Gatsby Carbon Theme as the underlying codebase.`}</p>
    <p>{`We will accomplish this by doing the following:`}</p>
    <ul>
      <li parentName="ul">{`Image Gallery component `}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/gatsby-theme-carbon/issues/229"
        }}>{`#229`}</a></li>
      <li parentName="ul">{`Spacing audit for all components in the theme `}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/gatsby-theme-carbon/issues/252"
        }}>{`#252`}</a></li>
      <li parentName="ul">{`Mobile specific images `}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/gatsby-theme-carbon/issues/249"
        }}>{`#249`}</a></li>
      <li parentName="ul">{`Sync up on content questions around UI pages `}<a parentName="li" {...{
          "href": "https://github.com/carbon-design-system/design-language-website/issues/94"
        }}>{`#94`}</a></li>
      <li parentName="ul">{`Close out outstanding bugs `}<a parentName="li" {...{
          "href": "https://github.com/orgs/carbon-design-system/projects/22"
        }}>{`#22`}</a></li>
    </ul>
    <h2 {...{
      "id": "continued-support"
    }}>{`Continued support`}</h2>
    <p>{`This project includes outreach, bug fixes, and issue triage.`}</p>
    {
      /*
      ## April 2019
      ### Core product
      - WCAG Compliance for core component libraries (vanilla and React)
      - Sketch kit themes
      - Data table functionality updates
      - Properties and state management
      - UI Shell v1
      - Design specs for unbuilt features
      - New feature requests
      - Theming
      - Document and templatize the pattern design process
      - Charts
      - Data visualization
      - Investigate feasibility / desirability of fluid components
      ### Process improvement
      - Sketch kit themes functionality
      - Dev tooling
      - Generate design assets from code
      - Tools to measure Carbon adoption
      ### Education and activation
      - 'Adopt a product' initiative
      - Class curriculum coursework
      - More tutorials
      - User testing and research
      - Expand enablement and education for contributing
      ### Governance and architecture
      - React as the source of truth, or introduce monorepo approach
      - Standardize components (specs, reporting, etc)
      - Define add-ons / user generated content approach
      ### Support
      - Clean up code comments
      - Expanded documentation and live demo
      - Define active support model / strategy
      ## More Information on Patterns
      Prioritize the most important compound components, layouts, and workflow patterns. Encourage bringing these in through contribution from extended teams.
      - Publish on the website the full list of **all** components that we propose, even if 0% complete.
      - Prioritize and solicit contributions based on follows and upvotes for components.
      #### Compound components
      - Shell (header, global navigation, avatar, left/right sidebars, breadcrumbs, footer)
      - Forms
      - Data table
      - Empty states
      - Date picker
      - Cards
      - Condition builder
      - Reporting
      - File uploader
      - Calendar/scheduler
      - Data visualization
      #### Page templates
      - Home page
      - Dashboard page
      - Detail page
      - Profile page
      - Catalog page
      - Billing and usage page
      - Management page
      - Docs page
      - Legal
      #### Workflow patterns
      - Login
      - First-time use
      - Registration
      - Searching
      - What’s new
      - Embedded help
      - Provisioning
      - Upgrading
      - Updating
      - Canceling
      - Favoriting
      ## Disclaimer
      This roadmap is not a delivery commitment and is subject to change based on user needs and feedback.
      _Last updated 4/22/2019_
      */
    }

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      